exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.email-pagos[data-v-58269c77]{\n    display: inline-block;\n    width: 70%;\n    margin-right: 11px;\n    margin-left: 12px;\n}\n.row-full[data-v-58269c77]{\n    background: #f7f7f7;\n    padding-top: 20px;\n    padding-bottom: 20px;\n    margin-bottom: 30px;\n    margin-left: 70px;\n    margin-left: 0px;\n    padding-left: 15px;\n}\n.preview[data-v-58269c77]{\n    border: 1px dotted #20a0ff;\n}\n.preview .container[data-v-58269c77]{\n    width: 1040px;\n}\n", ""]);

// exports
